module.exports = __webpack_public_path__ + "img/0Q3B5795_WoodMatted.ff79c600.jpg";